import { __assign } from "tslib";
import * as React from 'react';
import { themes } from '../../ThemeOptions';
var BootStrapTd = React.lazy(function () {
    return import('../../bootstrap-table-components/components/BTTd');
});
var bootStrapTd = function (props) {
    return React.createElement(BootStrapTd, __assign({}, props));
};
export var Td = function (props) {
    var componentToDisplay = bootStrapTd(props);
    switch (props.ioTheme.uiLibrary) {
        case 'bootstrap':
            componentToDisplay = bootStrapTd(props);
    }
    return React.createElement(React.Fragment, null, componentToDisplay);
};
Td.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default Td;
//# sourceMappingURL=Td.js.map